// action
import {
    SAVE_EMPLOYEE,
    SAVE_EMPLOYEE_FAIL,
    SAVE_EMPLOYEE_SUCCESS,
    SAVE_EMPLOYEE_RESET
} from '../action/saveEmployeeAction'
import { api_err_msg } from "../strings.json"

// initialState
const initialState = {
    apiState: "",
    data: {},
    message: ""
}

export default function (state = initialState, action) {
    switch (action.type) {
        case SAVE_EMPLOYEE:
            return {
                ...state,
                apiState: "loading"
            }
        case SAVE_EMPLOYEE_FAIL:
            return {
                ...state,
                apiState: "error",
                message: action.response && action.response.data && action.response.data.message || api_err_msg,
            }
        case SAVE_EMPLOYEE_SUCCESS:
            return {
                ...state,
                apiState: "success",
                message: action.response.data.message,
            }
        case SAVE_EMPLOYEE_RESET:
            return initialState
        default:
            return state
    }
}